export default __webpack_public_path__ + "static/media/edit.e5ee1e69.svg";